<template>
    <div class="container mx-auto text-center max-w-lg delivery-date">
        <h2 class="delivery-date--heading" v-text="$t('DELIVERY_DAY_WHEN_SHOULD')"></h2>
        <div class="delivery-date--container">
            <p class="delivery-date--sub-heading" v-html="$t('DELIVERY_DAY_PLEASE_CHOOSE', {'address.first_name': $t(`${address && address.first_name}`)})"></p>
            <div v-if="!hasMultipleDeliveriesSelected">
                <div v-for="slot in deliverySlots" :key="slot.label" class="delivery-date--slots">
                    <div class="delivery-date--circle" :style="getSlotColor(slot.color)"></div>
                    <p style="margin-top: 0px">{{ slot.label }}</p>
                </div>
            </div>

            <delivery-day></delivery-day>

            <div class="container mx-auto max-w-lg pt-6 pb-2 scroll-to-text-me">
                <h6>{{ $t('COURIER_NOTIFICATION') }}</h6>
                <p v-html="$t('DELIVERY_DAY_THE_COURIER', {'address.first_name': $t(`${address && address.first_name}`)})"></p>
            </div>

            <delivery-notification-new @toggle-next="toggleNext"></delivery-notification-new>
            <div class="pb-10">
                <submit-button class="btn btn--full-width btn--primary-black"  @click="submit" :disabled="isNextButtonDisabled" v-html="$t('DELIVERY_DAY_NEXT')"></submit-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SECTION_DELIVERY_DATE } from '@/constants/Gifting';
import { CSPageEvents } from '@/helpers/GAHelpers';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import DeliveryDay from '@/components/partials/account/gifting/DeliveryDay';
import DeliveryNotificationNew from '@/components/partials/account/gifting/DeliveryNotificationNew';

export default {
    name: 'GiftDetails',
    methods: {
        submit() {
            this.$store.commit('gifting/setSectionComplete', SECTION_DELIVERY_DATE);
            this.$router.push({ name: 'account.gifting.gift-card' });
            CSPageEvents('giftOneOff', {
                productType: 'gift',
                productFamily: this.selectedBoxName || this.defaultProductFamily,
                frequency: 'once',
            });
        },
        getSlotColor(color) {
            return {
                'background-color': `${color}`,
            };
        },
        toggleNext(value) {
            return this.isNextButtonDisabled = value;
        },
    },
    data() {
        return {
            isNextButtonDisabled: false,
            deliverySlots: [
                {
                    color: '#D9E5D0',
                    label: this.$t('HIGH_DELIVERY_SLOT'),
                },
                {
                    color: '#FDF0CF',
                    label: this.$t('LOW_DELIVERY_SLOT'),
                },
            ],
        };
    },
    computed: {
        ...mapGetters({
            hasMultipleDeliveriesSelected: 'gifting/isSubscription',
            address: 'address/getSelectedGiftingAddress',
            selectedBoxName: 'gifting/getSelectedBoxName',
            defaultProductFamily: 'register/getDefaultProductFamily',
        }),
    },
    components: {
        SubmitButton,
        DeliveryDay,
        DeliveryNotificationNew,
    },
};
</script>

<style lang="scss" scoped>
    .delivery-date{
        display: flex;
        align-items: center;
        flex-direction: column;
        &--heading {
            padding: 24px 0px;
        }
        &--container {
            height: 100%;
            max-width: 400px;
            text-align: left;
            @media (max-width: 768px) {
                max-width: 368px;
                margin: 0px 16px;
            }
        }
        &--sub-heading {
            margin-bottom: 24px;
        }
        &--slots {
            display: flex;
            flex-direction: row;
        }
        &--circle {
            height: 24px;
            width: 24px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
</style>
